import { VehicleCategory } from '@navio/nsdk';
import { type NoddiIconName } from 'noddi-ui-common';

export const VEHICLE_CATEGORY_ICON: Record<VehicleCategory, NoddiIconName> = {
  [VehicleCategory.PASSENGER]: 'Car',
  [VehicleCategory.LCV]: 'Car',
  [VehicleCategory.MOTORCYCLE]: 'Bike',
  [VehicleCategory.BUS]: 'Bus',
  [VehicleCategory.TRUCK]: 'Truck',
  [VehicleCategory.TRAILER]: 'Trailer',
  [VehicleCategory.OTHER]: 'CircleHelp'
};
